import { GraphDatumType } from 'dashboard/models/graph-datum-type';
import Action from 'lib/interfaces/Action';

export type GraphDatumTypeActions =
  | Action<GraphDatumTypeActionType.SetGraphDatumType, GraphDatumTypePayload>
  | Action<GraphDatumTypeActionType.ClearGraphDatumTypeData>;

export enum GraphDatumTypeActionType {
  SetGraphDatumType = 'graph/SET_GRAPH_DATUM_TYPE',
  ClearGraphDatumTypeData = 'graph/CLEAR_GRAPH_DATUM_TYPE_DATA',
}

interface GraphDatumTypePayload {
  graphDatumType: GraphDatumType;
}

export function setGraphDatumType(
  graphDatumType: GraphDatumType,
): Action<GraphDatumTypeActionType.SetGraphDatumType, GraphDatumTypePayload> {
  return {
    type: GraphDatumTypeActionType.SetGraphDatumType,
    payload: { graphDatumType },
  };
}

export function clearGraphDatumTypeData(): Action<GraphDatumTypeActionType.ClearGraphDatumTypeData> {
  return { type: GraphDatumTypeActionType.ClearGraphDatumTypeData };
}
